import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="py-20 md:py-32 bg-white" data-id="element-139">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-140">
        <FadeIn data-id="element-141">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-charcoal mb-10" data-id="element-142">
            La Trampa de la Disponibilidad
          </h2>
        </FadeIn>

        <div className="space-y-8 text-lg md:text-xl text-brand-charcoal/80 leading-relaxed text-left md:text-center" data-id="element-143">
          <FadeIn delay={0.1} data-id="element-144">
            <p data-id="element-145">
              La mayoría de las asistentes virtuales latinas en USA caen en la
              "trampa de la disponibilidad". Creen que responder en 30 segundos
              es lo que las hace valiosas. La realidad es que eso solo te
              convierte en un gasto reemplazable para el cliente.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-146">
            <p data-id="element-147">
              Vives en un estado de{' '}
              <strong className="text-brand-charcoal font-semibold border-b-2 border-brand-gold/50" data-id="element-148">
                micro-caos operativo
              </strong>
              . Saltas de una pestaña de Slack a un diseño en Canva, mientras tu
              bandeja de entrada sigue creciendo.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-149">
            <p data-id="element-150">
              Al final del día, estás agotada, pero sientes que no has avanzado
              en nada importante. Estás a un error de distancia de perder a tu
              mejor cliente porque tu cerebro simplemente no puede procesar más
              notificaciones.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}